import React from 'react'
import { connect } from 'react-redux'
import Overlay from './Overlay.js'
import ContentBox from './ContentBox.js'
import QuestionNav from './QuestionNav.js'
import './Menu.css'

const Menu = ({ isMenuOpen, onMenuClose }) => {
  return (
    <Overlay
      isVisible={isMenuOpen}
      onClick={e => e.target === e.currentTarget && onMenuClose()}
    >
      <ContentBox>
        <QuestionNav />
      </ContentBox>
    </Overlay>
  )
}

const mapStateToProps = ({ isMenuOpen }) => ({
  isMenuOpen,
})

const mapDispatchToProps = ({ isMenuOpen: { toggle } }) => ({
  onMenuClose: () => toggle(),
})

export default connect(mapStateToProps, mapDispatchToProps)(Menu)



// WEBPACK FOOTER //
// ./src/components/Menu.js